const words = [
  "Housing Stability",
  "Independence",
  "Dignity",
  "Community",
  "Family",
  "Support",
];

const Marquee = () => (
  <section data-testid="marquee-section" className="relative py-16 md:py-24 border-y border-[#1A1A1A]/10 overflow-hidden">
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
          {words.map((w) => (
            <span key={`${dup}-${w}`} className="flex items-center">
              <span className="font-serif-display italic font-light text-5xl md:text-7xl text-[#1A1A1A] px-8">
                {w}
              </span>
              <span className="text-[#C85A3C] text-3xl md:text-5xl">&#10022;</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);

export default Marquee;
